import React from "react";
import Link from "../Link";

const HeroBanner = () => {
  return (
    <div className="absolute top-0 left-0 right-0 z-[4] bg-[#d93e1b] text-white px-4 py-3">
      <div className="mx-auto max-w-screen-lg text-center leading-relaxed space-y-2 mt-20">
        <p>
          Ab sofort:{" "}
          <Link
            href="/#dienstleistungen"
            className="font-bold underline hover:opacity-80 cursor-pointer"
          >
            Neukundenbonus
          </Link>{" "}
          auf das erste hochgeladene Fahrzeug!
        </p>
      </div>
    </div>
  );
};

export default HeroBanner;
